import { getStats } from '@/api/conversations'
import { resolveAccountId } from '@/store/helpers/account'

const state = {
  // Personal counters, tab counts and unread per conversation. Polled from the
  // header, so the badge and the chime work on every page, not only the list.
  data: null,
}

export const getters = {
  getStats: $state => $state.data,
  getUnreadByConversation: $state => $state.data?.unread || {},
  getUnreadTotal: $state =>
    Object.values($state.data?.unread || {}).reduce(
      (total, count) => total + count,
      0
    ),
}

export const actions = {
  async fetch({ commit, dispatch, rootGetters }) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    if (!accountId) return

    const { data } = await getStats(accountId)
    commit('SET_STATS', data)
  },
}

export const mutations = {
  SET_STATS($state, data) {
    $state.data = data
  },
}

export default { namespaced: true, state, getters, actions, mutations }
